import Fallback from "app/components/Fallback";
import React from "react";

const Home = React.lazy(() => import("app/modules/website-builder/home/Home"));
const GalleryAndLinks = React.lazy(() =>
  import("app/modules/website-builder/gallery/GalleryAndLinks")
);
const AboutUs = React.lazy(() =>
  import("app/modules/website-builder/aboutUs/AboutUs")
);
const Academics = React.lazy(() =>
  import("app/modules/website-builder/academics/Academics")
);
const AchievementsHub = React.lazy(() =>
  import("app/modules/website-builder/achievementsHub/AchievementsHub")
);
const AlumniAchiever = React.lazy(() =>
  import("app/modules/website-builder/AlumniAchiever")
);
const ChiefGuest = React.lazy(() =>
  import("app/modules/website-builder/ChiefGuest")
);

const SportAchiever = React.lazy(() =>
  import("app/modules/website-builder/SportAchiever")
);

export const HomePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Home {...props} />
  </React.Suspense>
);
export const GalleryAndLinksPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <GalleryAndLinks {...props} />
  </React.Suspense>
);
export const AboutUsPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AboutUs {...props} />
  </React.Suspense>
);
export const AcademicsPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Academics {...props} />
  </React.Suspense>
);
export const AchievementsHubPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AchievementsHub {...props} />
  </React.Suspense>
);
export const AlumniAchieverPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AlumniAchiever {...props} />
  </React.Suspense>
);
export const ChiefGuestPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <ChiefGuest {...props} />
  </React.Suspense>
);
export const SportAchieverPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <SportAchiever {...props} />
  </React.Suspense>
);
